import React, { useState } from 'react';

interface MoreOptionsProps {
  children: React.ReactNode;
  label?: string;
  defaultOpen?: boolean;
}

const MoreOptions: React.FC<MoreOptionsProps> = ({
  children,
  label = 'Mais opções',
  defaultOpen = false,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className={`more-options${open ? '' : ' collapsed'}`}>
      <button
        type="button"
        className="more-options-toggle"
        onClick={() => setOpen(o => !o)}
        style={{ width: '100%', background: 'none', border: 'none', padding: 0 }}
      >
        {label}
        <span className="chev">{open ? '▴' : '▾'}</span>
      </button>
      <div className="more-options-body">{children}</div>
    </div>
  );
};

export default MoreOptions;
